// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseItem_wrapper__rZ+Ui","avatar":"CourseItem_avatar__Jay-g","author":"CourseItem_author__KYns2"};